import { render, staticRenderFns } from "./MultiUserLabel.vue?vue&type=template&id=588bbbce&scoped=true"
import script from "./MultiUserLabel.vue?vue&type=script&lang=js"
export * from "./MultiUserLabel.vue?vue&type=script&lang=js"
import style0 from "./MultiUserLabel.vue?vue&type=style&index=0&id=588bbbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588bbbce",
  null
  
)

export default component.exports